module.exports = __webpack_public_path__ + "img/en-este-momento.9f88592c.svg";